import { render, staticRenderFns } from "./LatestNewsAdmin.vue?vue&type=template&id=63551bd6&scoped=true&"
import script from "./LatestNewsAdmin.vue?vue&type=script&lang=js&"
export * from "./LatestNewsAdmin.vue?vue&type=script&lang=js&"
import style0 from "./LatestNewsAdmin.vue?vue&type=style&index=0&id=63551bd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63551bd6",
  null
  
)

export default component.exports